import {
  Link as RouterDomLink,
  LinkProps as RouterDomLinkProps,
} from 'react-router-dom';

import { Link, TLink } from '../lib/Link';

export type TRouterLinkProps = TLink & Omit<RouterDomLinkProps, 'component'>;

export const RouterLink = ({ ...props }: TRouterLinkProps) => {
  return <Link component={RouterDomLink} {...props} />;
};
